module.exports = __webpack_public_path__ + "static/media/novo-logo-light.87e6ce2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/novo-logo-light.svg
// module id = 145
// module chunks = 0